export default {"src":"/_next/static/media/feature-1.26621d6a.svg","height":185,"width":218,"blurWidth":0,"blurHeight":0};